var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThiefWeapon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 13 5",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#c7c6c3",
    d: "M9 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bdbbb8",
    d: "M10 0h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b3b0ac",
    d: "M11 0h1M8 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d6d8dc",
    d: "M0 2h6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c2c5ca",
    d: "M6 2h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#77746f",
    d: "M8 2h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a0bcde",
    d: "M9 2h1M11 2h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#72a1d9",
    d: "M10 2h1M12 2h1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9ea2a7",
    d: "M2 3h2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8f9295",
    d: "M4 3h2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7f8286",
    d: "M6 3h2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#58554f",
    d: "M8 3h1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#091b30",
    d: "M9 3h1M11 3h1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#152a42",
    d: "M10 3h1M12 3h1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d2c28",
    d: "M8 4h1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThiefWeapon);
export default __webpack_public_path__ + "static/media/thief-weapon.75dc20e63b01fda420eddf41819bb6b9.svg";
export { ForwardRef as ReactComponent };